import { StyleSheet } from 'react-native'
// import Color from 'color'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.beige,
  },
  modalFullContainer: {
    paddingTop: '30%',
    paddingHorizontal: v.SPACE_SM,
  },
  patientContainer: {
    // backgroundColor: 'red'
  },
  actionBox: {
    marginTop: v.SPACE_LG,
  },
  actionButton: {
    marginVertical: v.SPACE_XS,
  },
  secondaryText: {
    paddingHorizontal: v.SPACE_SM,
  },
  leadHelp: {
    textAlign: 'center',
    marginBottom: v.SPACE_MD,
    paddingHorizontal: v.SPACE_MD,
  },
  actionButton: {
    marginBottom: v.SPACE_SM,
  },
})

export default styles
